<div class="modal-header"><h2 class="modal-title">Add Time</h2></div>
<div class="modal-body">
    <div class="flex-fill d-flex flex-column">
        <div class="card">
            <div class="card-body">
                <dx-form *ngIf="entity" [formData]="entity" validationGroup="mainValidationGroup">
                    <dxi-item dataField="created" editorType="dxDateBox"  [label]="{ text: 'Date' }">
                        <dxi-validation-rule type="required" message="Required"> </dxi-validation-rule>
                        <dxi-validation-rule type="range" [min]="minDate" message="Cannot be less than 10 days ago"> </dxi-validation-rule>
                    </dxi-item>
                    <dxi-item dataField="quantity" [label]="{ text: 'Qty' }">
                        <dxi-validation-rule type="required" message="Quantity Required"> </dxi-validation-rule>
                        <dxi-validation-rule type="numeric" message="Needs to be a number"> </dxi-validation-rule>
                        <dxi-validation-rule type="range" [min]="0.25" message="Cannot be less than 0.25"> </dxi-validation-rule>
                    </dxi-item>
                    <dxi-item dataField="description" [label]="{ text: 'Description' }">
                        <dxi-validation-rule type="required" message="Description Required"> </dxi-validation-rule>
                    </dxi-item>
                </dx-form>
            </div>
        </div>
    </div>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="save()">Save</button>
    <button type="button" class="btn btn-default" (click)="cancel()">Close</button>
</div>
